import { Progress } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { useNotification } from 'hooks/useNotification'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC, KeyboardEventHandler, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TableInput } from 'views/components/Table/Controls/TableInput'
import CellProgress from './CellProgress'
import { BidPriceTableCellProps } from './types'

const PriceCell: FC<BidPriceTableCellProps> = ({ currentValue, bid, refetch }) => {
  const { t } = useTranslation('bid')
  const notify = useNotification()
  const [value, setValue] = useState(currentValue)

  const [progress, execute, error] = useAProgress(
    async (price) => {
      await apiClient.patch(endpoints.bid(bid.id), { price: Number(price) })
      await refetch()
    },
    {
      eventName: 'price',
      scope: 'change',
      onSuccess: () => notify(Progress.SUCCESS, { title: t('form.notifyEditSuccess') }),
    },
  )

  const updatePrice = (price) => {
    if (Number(price) === Number(currentValue)) {
      return
    }
    return execute(price)
  }

  const onKeyDown: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key !== 'Enter' || progress === Progress.WORK) {
      return
    }
    updatePrice(value)
  }

  return (
    <>
      <CellProgress enabled={progress === Progress.WORK} />
      <TableInput
        error={!!error}
        onChange={(e) => setValue(e.target.value)}
        onBlur={() => updatePrice(value)}
        onKeyDown={onKeyDown}
        value={value}
        visible
        disabled={progress === Progress.WORK}
      />
    </>
  )
}

export default PriceCell
